import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { IUserTransaction } from '../../models/UserTransaction';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { LinkStyle, tableStyle } from '../../style/antdCssProperty';
import { format } from 'date-fns';
import { getPayType } from '../../libs/helper';

interface IProps {
  userTransactions: IUserTransaction[];

  onClick?(e: React.MouseEvent<HTMLAnchorElement>, userTransaction: IUserTransaction): void;
}

const TransactionTable: FC<IProps> = ({ userTransactions, onClick }) => {
  const columns: ColumnsType<IUserTransaction> = [
    {
      title: 'Id',
      key: 'id',
      dataIndex: 'id',
      render: (value, record) => onClick ?
        <a onClick={(e) => onClick(e, record)} style={LinkStyle}>{record.id}</a> : record.id,
    },
    {
      title: '주문번호',
      dataIndex: 'mbrRefNo',
      render: (value, record) => onClick ?
        <a onClick={(e) => onClick(e, record)} style={LinkStyle}>{record.mbrRefNo}</a> : record.mbrRefNo,
    },
    {
      title: '승인번호',
      dataIndex: 'appNo',
    },
    {
      title: '수업구분',
      key: 'productName',
      render: (value, record) => (
        record.product.name
      ),
    },
    {
      title: '과정',
      key: 'courseName',
      render: (value, record) => (
        record.course.name
      ),
    },
    {
      title: '고객',
      key: 'userName',
      render: (value, record) => (
        // customer/115
        <Link to={`/customer/${record.user.id}`} style={LinkStyle}>{record.user.name} ({record.user.id})</Link>
      ),
    },
    {
      title: '전화번호',
      render: (value, record) => record.user.phone,
    },
    {
      title: '학생',
      key: 'studentName',
      render: (value, record) => (
        `${record.student.name} (${record.student.id})`
      ),
    },
    {
      title: '이메일',
      key: 'email',
      render: (value, record) => (
        record.user.email
      ),
    },
    {
      title: '결제대금',
      key: 'amount',
      dataIndex: 'amount',
    },
    {
      title: '할인금액',
      key: 'couponAmount',
      dataIndex: 'couponAmount',
    },
    {
      title: '상태',
      key: 'status',
      render: (value, record) => (
        record.deletedAt ? <>
          결제취소<br />{format(new Date(record.deletedAt), 'yyyy.MM.dd')}
        </> : '결제완료'
      ),
    },
    {
      title: '결제일',
      key: 'createdAt',
      render: (value, record) => (
        format(new Date(record.createdAt), 'yyyy.MM.dd HH:mm:ss')
      ),
    },
    {
      title: '구분',
      key: 'channel',
      render: (value, record) => getPayType(record),
    },
    {
      title: '재수강',
      key: 'isRepayment',
      render: ({ isRepayment }: IUserTransaction) => isRepayment ? 'Y' : 'N',
    },
    {
      title: '수업 취소',
      dataIndex: 'cancelClassCount',
    },
    // {
    //   title: '',
    //   key: 'deletedAt',
    //   render: (value, record) => (
    //     record.deletedAt ? '사유' : '취소'
    //   ),
    // },
  ];

  return (
    <>
      <Table
        style={tableStyle}
        dataSource={userTransactions}
        columns={columns}
        size='small'
        rowKey='id'
        pagination={false}
      />
    </>
  );
};

export default TransactionTable;
